import { Baby, House, Milk, Moon, Syringe } from 'lucide-react';

const ITEMS = [
  { id: 'home', label: '首页', icon: House },
  { id: 'feed', label: '吃', icon: Milk },
  { id: 'diaper', label: '拉', icon: Baby },
  { id: 'sleep', label: '睡', icon: Moon },
  { id: 'vaccine', label: '疫苗', icon: Syringe },
];

export default function BottomNav({ active, onChange }) {
  return (
    <nav className="bottom-nav" aria-label="主导航">
      {ITEMS.map(({ id, label, icon: Icon }) => (
        <button key={id} type="button" className={active === id ? 'is-active' : ''} onClick={() => onChange(id)} aria-current={active === id ? 'page' : undefined}>
          <Icon size={21} strokeWidth={active === id ? 2.4 : 1.9} aria-hidden="true" />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
